import { ICategoryCombo, ICategoryComboResponse } from "../../../model/respone/category/ICategoryCombo"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eCategoryComboActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as ICategoryComboResponse[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | ICategoryCombo,
    CLOSE_EDIT_MODAL: undefined,
    
    SAVE_START: {} as ICategoryCombo,
    SAVE_SUCCESS: {} as ICategoryCombo,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",


}
export const eCategoryComboActionTypeIds = generateActionTypeIds(eCategoryComboActionTypeDefine, "CATEGORY_COMBO")

export type ICategoryComboActions = IGenericActionType<typeof eCategoryComboActionTypeDefine, "CATEGORY_COMBO">

